import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'
import { Grid, Alert } from '@mui/material';
import AnimalContent from './content/main';
import breeds from '../statics/breeds.json'
import { RacePageHeader } from './racepage/header';
import SEO from './seo/seo';
import axios from 'axios';
import { backend } from '../statics/system_variables'
import FightDog from './racepage/questions/fight_dog';
import Cost from './racepage/questions/cost';
import FightDogStates from './racepage/questions/fight_dog_states';


export default function RacePage() {
    const location = useLocation();
    const name = decodeURI(location.pathname.split('/')[2])

    const breed_json = getBreedJson(name)
    if (breed_json == null) {
        // TODO: return 404
    }

    const [desciption, setDesciption] = useState('Ergebnisse für die Rasse ' + name + '. In Kürze wird hier - wenn verfügbar - eine kurze Rassenbeschreibung geladen. Es ist jedoch nicht zu jeder Rasse eine Beschreibung verfügbar.')
    const [dogs, setDogs] = useState()

    useEffect(() => {
        const api_link = backend + '/breed_description?breed_id=' + breed_json.nr
        axios.get(api_link)
            .then(({ data }) => {
                setDesciption(data)
            })
            .catch(() => {
                // Keep default description in case of error
            })
    }, [name, breed_json.nr])

    return (
        <>
            <SEO
                title={name + " adoptieren - " + (dogs ? dogs[2] + " Treffer - PocketPet " : "PocketPet")}
                description={'Adoptiere deinen ' + name + ' auf PocketPet, dem online Tierheim. Wir vermitteln dir deinen Traumhund.'}
                keywords={[name]}
                type='website' />

            <Grid container mb={20} sx={{ p: { xs: 3, xl: 0 } }}>
                <Grid item xs={0} xl={3} />
                <Grid item xs={12} xl={6} mb={5}>
                    <RacePageHeader description={desciption} />
                    {dogs ? <Alert variant='outlined' severity={dogs[2] > 0 ? 'success' : 'error'} sx={{ textAlign: 'center', justifyContent: 'center' }} component='h2'>
                        {dogs[2] > 0 ? dogs[2] + ' Hunde aus deutschen Tierheimen gefunden' : 'Diese Suche lieferte keine Resultate. Vielleicht solltest du die Filter ändern.'}
                    </Alert>: <Alert variant='outlined' severity='info' sx={{ textAlign: 'center', justifyContent: 'center' }} component='h2'>Hunde werden aus deutschen Tierheimen gesucht</Alert>}
                </Grid>
                <Grid item xs={0} xl={3} />

                <Grid item xs={0} xl={3}>
                </Grid>

                <Grid item xs={12} xl={6} mb={10}>
                    <AnimalContent breed_id={breed_json.nr} setDogs={setDogs} />
                </Grid>

                <Grid item xs={0} xl={3}>
                </Grid>

                <Grid item xs={0} xl={3}>
                </Grid>

                <Grid item xs={12} xl={6}>
                    <Cost breed={breed_json} />
                    <FightDog breed={breed_json} />
                    <FightDogStates breed={breed_json} />
                </Grid>

                <Grid item xs={0} xl={3}>
                </Grid>
            </Grid>
        </>)
}


function getBreedJson(name) {
    const json_official = breeds.filter(function (breeds) { return breeds.breed === name })[0]
    if (json_official !== undefined) {
        return json_official
    }

    const json_alternative = breeds.filter(function (breeds) { return breeds.alternativnamen == null ? false : breeds.alternativnamen.split(',').includes(name) })[0]
    if (json_alternative !== undefined) {
        return json_alternative
    }

    return null
}